var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-form',{attrs:{"endpoint":"grupo-conteudo","rota-base":"/admin/grupo-conteudo","titulo-singular":"Grupo de Conteúdo","campos-extras":[{"campo":"descricao","label":"Descrição","tipo":"text","span":24}]}})
}
var staticRenderFns = []

export { render, staticRenderFns }